import bus from "@/utils/bus";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import "./index.less";
import { hasClass } from "@/components/Calendars/utils/handleClass";
import { connect } from "dva";
import { ISideThemes, UserState } from "@/models/user";
import { Avatar } from "@/baseComponents/Avatar";
import { changeEgovUrl } from "@/utils/tools";
import { useHistory } from "react-router-dom";
import { ThirdAppState } from "@/models/thirdapp";
import { sleep } from "@/utils/chat/message";
import SvgIcon from "@/baseComponents/SvgIcon";
import { appTrailApply } from "@/components/ThirdApp/utils";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { notifyer } from "@/components/ThirdApp";
import { v4 } from "uuid";
import { ThirdAppOpenType } from "@/types/common";
import { isFocusEnv, FocusSDK } from "@/utils";
export interface NavItemData {
  path: string;
  title: string;
  name?: string;
  navName?: string;
  icon: any;
  tip?: any;
  [key: string]: any;
}

interface Props extends NavItemData {
  active?: boolean;
  onClick?: (name: string) => void;
  onDoubleClick?: (name: string) => void;
}

interface IStateProps {
  sideThemes: ISideThemes;
}

function NavItem(props: Props & IStateProps) {
  const {
    active,
    path,
    title,
    icon,
    activeIcon,
    tip,
    name,
    navName,
    sideThemes,
    iconUrl,
    iconSvg,
    applicationId,
    thirdAppMap,
    themes,
    role,
    pcUrl,
    openType,
    homeUrl,
    uuid
  } = props;
  const history = useHistory();
  const navItemRef = useRef(null);
  const [isHover, setIsHover] = useState(false);
  const { authInfo } = useContext<GlobalContextConfig>(GlobalContext);
  const svgColor = useMemo(() => {
    if (themes === "themeWhite") {
      return "#8f959e";
    } else {
      return "#ffffffb3";
    }
  }, [themes]);
  const onClick = async () => {
    console.log(`tj:>>>onclick11>>>applicationId>`, applicationId);
    if (applicationId) {
      const appInfo: any = thirdAppMap[applicationId];
      if (openType && openType === ThirdAppOpenType.WORKPLACE) {
        try {
          history.push("/third_apps");
          if (!appInfo) {
            return false;
          }
          await sleep(300);
          appTrailApply(
            appInfo.applicationId,
            () => {
              bus.emit("openThirdApp", appInfo);
            },
            notifyer,
            appInfo
          );
          return;
        } catch (e) {}
      } else if (openType && openType === ThirdAppOpenType.INNER_FRAME) {
        if (!isFocusEnv()) {
          window.open(pcUrl);
          return;
        }
        console.log(`tj:>>>onclick222>>>applicationId>`, appInfo);
        history.push(`/linkContainer?url=${encodeURIComponent(homeUrl)}`);
        setTimeout(() => {
          bus.emit("linkContainer:linkUrl", {
            url: homeUrl,
            appInfo
          });
          bus.emit("layout:LeftNav:scene-item-change", uuid);
        }, 0);
        return;
      } else if (openType && openType === ThirdAppOpenType.INNER_BROWSER) {
        window.open(homeUrl);
        return;
      } else {
        FocusSDK.openUrl(homeUrl);
        return;
      }
    } else if (role === "loadUrl" && pcUrl) {
      console.log(`tj:>>>onclick333>>>applicationId>`, role);
      if (!isFocusEnv()) {
        window.open(pcUrl);
        return;
      }
      history.push(`/linkContainer?url=${encodeURIComponent(pcUrl)}`);
      setTimeout(() => {
        bus.emit("linkContainer:linkUrl", {
          url: pcUrl
        });
      });
      if (!active && props.onClick) {
        props.onClick("");
      }
      return;
    }
    if (!active && props.onClick) {
      props.onClick(path);
    }
  };
  const onDoubleClick = () => {
    if (props.onDoubleClick) {
      props.onDoubleClick(path);
    }
  };
  useEffect(() => {
    if (navName !== "calendar") return;
    function handleNav() {
      const selNav: any = navItemRef.current;
      if (hasClass(selNav, "calendar")) {
        selNav?.click();
      }
    }
    bus.on("nav:calendar-nav-click", handleNav);
    return () => {
      bus.off("nav:calendar-nav-click", handleNav);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavClick = useCallback(() => {
    const selNav: any = navItemRef.current;
    selNav?.click();
  }, []);

  useEffect(() => {
    bus.on(`nav:default-nav-click:${name}`, handleNavClick);
    return () => {
      bus.off(`nav:default-nav-click:${name}`, handleNavClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);
  // const bar = (
  //     <div
  //         style={{
  //             position: 'absolute',
  //         }}
  //     />
  // );
  const tipComp = (
    <div className="nav-new-badge-tip">
      <span>{Number(tip) > 99 ? "99+" : tip}</span>
    </div>
  );
  return (
    <div
      ref={navItemRef}
      role="button"
      tabIndex={0}
      className={[`focus-nav-item ${navName}`, active ? "active" : ""].join(" ")}
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // padding: '10px 0',
        outline: 0,
        cursor: "pointer",
        background: (isHover || active) && sideThemes.secondary ? sideThemes.secondary : ""
      }}
      onClick={() => {
        onClick?.();
        // 因为工作台增加了缓存机制，导致切换tab时，工作台大搜不能关闭。有点不太合理，但是改不动了只能这样了
        bus.emit("onHideGlobalSearch", path);
        bus.emit("onNavItemClick", path);
      }}
      onDoubleClick={onDoubleClick}
      onKeyDown={() => {}}
      onMouseEnter={sideThemes.secondary ? () => setIsHover(true) : () => {}}
      onMouseLeave={sideThemes.secondary ? () => setIsHover(false) : () => {}}
    >
      <div
        style={{
          fontSize: 22,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // width: 22,
          height: 22
        }}
      >
        {iconSvg ? (
          <SvgIcon
            url={iconSvg}
            style={{
              width: "22px",
              height: "22px",
              backgroundColor: active ? sideThemes.activePrimary : sideThemes.iconPrimary
            }}
          />
        ) : iconUrl ? (
          <Avatar avatarMask={false} src={changeEgovUrl(iconUrl)} styleObj={{width: 22, height: 22, fontSize: "9px"}}/>
        ) : active ? (
          activeIcon
        ) : (
          icon
        )}
      </div>
      <div className="nav-item-name ellipsis">{title || name}</div>
      {/** 下面这句代码无用，可以去掉 */}
      {/* {active && bar} */}
      {authInfo && !!tip && tipComp}
    </div>
  );
}

function mapStateToProps({ user, thirdapp }: { user: UserState; thirdapp: ThirdAppState }) {
  const { sideThemes, themes } = user;
  const { thirdAppMap } = thirdapp;
  return {
    sideThemes,
    themes,
    thirdAppMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(NavItem);
